<template>
  <div :class="['check-box', cartTheme && 'check-box--cart', validity && 'check-box--validity']">
    <div class="check-box__wrapper">
      <button
        @click="onClickHandler"
        :class="[
          'check-box__selector',
          showCheck && 'check-box__selector--selected',
          disabled && 'check-box__selector--disabled',
        ]"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'CheckBox',
  data() {
    return {
      check: false,
    }
  },
  props: {
    cartTheme: {
      type: Boolean,
      required: false,
      default: false,
    },
    validity: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    ...mapMutations({
      setIsLoadingCaptcha: 'app/IS_LOADING_CAPTCHA_UPDATED',
    }),
    onClickHandler() {
      if (this.$listeners['click-handler']) {
        this.$emit('click-handler')
      }
      this.check = !this.check
    },
  },
  computed: {
    ...mapState({
      isComponentLoading: state => state.app.isComponentLoading,
      isLoadingCaptcha: state => state.app.isLoadingCaptcha,
    }),
    showCheck: {
      // getter
      get() {
        return this.check
      },
      // setter
      set(newValue) {
        this.check = newValue
      },
    },
  },
  mounted() {
    if (this.isSelected) this.check = true
  },
  watch: {
    isSelected(value) {
      this.check = value
    },
  },
}
</script>

<style lang="scss">
.check-box {
  $this: &;
  height: 30px;
  &__selector {
    width: 30px;
    height: 30px;
    border-radius: 7px;
    background: transparent;
    border: 1px solid var(--light-blue-gray);
    &--selected {
      background: var(--light-green-translucid);
      border: 1px solid var(--strong-light-green);
      &:before {
        display: block;
        content: '\2713';
        text-align: center;
        font-size: rem(16);
        color: var(--white);
        font-family: var(--font-bold);
      }
    }
  }
  &--cart {
    height: 30px;
    #{$this} {
      &__selector {
        width: 24px;
        height: 24px;
        border-radius: 8px;
        background: transparent;
        border: 1px solid var(--white);
        cursor: pointer;
        &:hover {
          border: 1px solid var(--white);
        }
        &--selected {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid var(--white);
          &:before {
            display: block;
            content: '\2713';
            text-align: center;
            font-size: rem(10px);
            color: var(--white);
            font-family: var(--font-bold);
          }
        }
        &--disabled {
          cursor: auto;
          border: 1px solid var(--gray-7);
          background: none;
          &:before {
            display: block;
            content: '\2713';
            text-align: center;
            font-size: rem(10px);
            color: var(--gray-7);
            font-family: var(--font-bold);
          }
          &:hover {
            border: 1px solid var(--gray-7);
          }
        }
      }
    }
  }
  &--validity {
    height: auto;
    #{$this} {
      &__selector {
        width: 20px;
        height: 20px;
        border-radius: 5px;
        background: transparent;
        border: 1px solid var(--gray-5);
        cursor: pointer;
        pointer-events: none;
        &--selected {
          border: 1px solid var(--strong-light-green);
          position: relative;
          bottom: 1px;
          &:before {
            display: block;
            content: '\2713';
            text-align: center;
            font-size: rem(12px);
            color: var(--strong-light-green);
            position: relative;
            right: 3px;
          }
        }
      }
    }
  }
}
</style>
